import makeActionCreator from './makeActionCreator';
import {
  FILTER_BY_SEARCH_TERM,
  FILTER_BY_SEARCH_TERM_DONE,
  FILTER_BY_SEARCH_TERM_ERROR,
  FILTER_BY_SEARCH_TERM_LOADING,
  FILTER_BY_SEARCH_TERM_SUCCESS
} from './actionTypes';

// Create your Action Creators here...
export const filterBySearchTerm = makeActionCreator(FILTER_BY_SEARCH_TERM, 'arraysOfStrings',
  'searchTerm');
export const filterBySearchTermLoading = makeActionCreator(FILTER_BY_SEARCH_TERM_LOADING);
export const filterBySearchTermSuccess = makeActionCreator(FILTER_BY_SEARCH_TERM_SUCCESS,
  'filteredArray');
export const filterBySearchTermError = makeActionCreator(FILTER_BY_SEARCH_TERM_ERROR, 'error');
export const filterBySearchTermDone = makeActionCreator(FILTER_BY_SEARCH_TERM_DONE);
